import React, { ReactElement, useEffect, useState } from "react";
import { useLocation } from "react-router";

export const ScrollToTop = (props: {children?: ReactElement | ReactElement[]}): ReactElement => {
  const location = useLocation();
  const [prevPath, setPrevPath] = useState<string>();

  useEffect(() => {
    if (prevPath !== location.pathname) {
      document.body.scrollTo(0,0);
    }
    setPrevPath(location.pathname);
  }, [location, prevPath]);

  return <>{props.children}</>
};
